import { render } from "./StakeModal.vue?vue&type=template&id=57dc6aca&scoped=true"
import script from "./StakeModal.vue?vue&type=script&lang=js"
export * from "./StakeModal.vue?vue&type=script&lang=js"

import "./StakeModal.vue?vue&type=style&index=0&id=57dc6aca&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57dc6aca"]])

export default __exports__